import React from 'react';
import { Box, Container, Typography, Card, CardContent, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useAuthModal } from '../auth/AuthManager';
// import eliminado: usar solo AuthContext
import PublicNavigation from '../navigation/PublicNavigation';

// Styled Components
const HeroSection = styled('section')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '80px 10%',
  gap: '60px',
  background: 'linear-gradient(135deg, #faf5ec 0%, #fff 50%, #f5f0e8 100%)',
  position: 'relative',
  overflow: 'hidden',
  '@media (max-width: 768px)': {
    flexDirection: 'column',
    textAlign: 'center',
    padding: '60px 5%',
    gap: '30px',
  },
});

const HeroText = styled('div')({
  flex: 1,
  maxWidth: '550px',
  zIndex: 1,
  '& h2': {
    color: '#806749',
    fontSize: '16px',
    marginBottom: '15px',
    textTransform: 'uppercase',
    letterSpacing: '2px',
    fontWeight: 600,
  },
  '& h1': {
    color: '#244b2c',
    fontSize: '56px',
    lineHeight: 1.1,
    marginBottom: '20px',
    fontWeight: 700,
    fontFamily: "'Playfair Display', serif",
    '@media (max-width: 768px)': {
      fontSize: '38px',
    },
  },
  '& p': {
    fontSize: '17px',
    lineHeight: 1.7,
    marginBottom: '30px',
    color: '#555',
  },
});

const HeroImage = styled('div')({
  flex: 1,
  zIndex: 1,
  '& img': {
    borderRadius: '25px',
    boxShadow: '0 15px 40px rgba(0, 0, 0, 0.15)',
    width: '100%',
    maxWidth: '500px',
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.02)',
    },
  },
});

const StyledButton = styled(Button)({
  background: 'linear-gradient(135deg, #2e5a33 0%, #3d7342 100%)',
  color: '#fff',
  padding: '16px 40px',
  borderRadius: '30px',
  fontWeight: 600,
  fontSize: '16px',
  transition: 'all 0.3s ease',
  boxShadow: '0 4px 15px rgba(46, 90, 51, 0.3)',
  '&:hover': {
    background: 'linear-gradient(135deg, #3d7342 0%, #2e5a33 100%)',
    transform: 'translateY(-3px)',
    boxShadow: '0 6px 20px rgba(46, 90, 51, 0.4)',
  },
});

const ProductsSection = styled('section')({
  textAlign: 'center',
  padding: '100px 8%',
  backgroundColor: '#fffaf2',
  '& h2': {
    color: '#2e5a33',
    fontSize: '42px',
    marginBottom: '15px',
    fontWeight: 700,
    fontFamily: "'Playfair Display', serif",
  },
  '& .subtitle': {
    color: '#666',
    fontSize: '18px',
    marginBottom: '60px',
    fontWeight: 400,
  },
});

const ProductCard = styled(Card)({
  borderRadius: '20px',
  boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
  overflow: 'hidden',
  transition: 'all 0.3s ease',
  cursor: 'pointer',
  '&:hover': {
    transform: 'translateY(-8px)',
    boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
  },
});



const ProductImage = styled('img')({
  width: '100%',
  height: '250px',
  objectFit: 'cover',
  transition: 'transform 0.5s ease',
  '.MuiCard-root:hover &': {
    transform: 'scale(1.1)',
  },
});

const WhatsAppButton = styled(Button)({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '12px',
  marginTop: '20px',
  background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
  color: 'white',
  padding: '18px 45px',
  borderRadius: '30px',
  fontWeight: 600,
  fontSize: '17px',
  letterSpacing: '0.5px',
  transition: 'all 0.3s ease',
  boxShadow: '0 4px 15px rgba(37, 211, 102, 0.3)',
  '&:hover': {
    background: 'linear-gradient(135deg, #128C7E 0%, #25D366 100%)',
    transform: 'translateY(-3px)',
    boxShadow: '0 6px 25px rgba(37, 211, 102, 0.4)',
  },
});

const StyledFooter = styled('footer')({
  background: 'linear-gradient(135deg, #4b2e12 0%, #3a2410 100%)',
  color: 'white',
  padding: '60px 0 30px',
});

const publicProducts = [
  {
    id: 1,
    name: 'Piñones Premium 500g',
    description: 'Piñones de araucaria de la mejor calidad, tostados artesanalmente',
    price: 25000,
    image: 'https://images.unsplash.com/photo-1448043552756-e747b7a2b2b8?w=600&h=400&fit=crop',
    stock: 15,
    category: 'Frutos Secos',
  },
  {
    id: 2,
    name: 'Miel de Araucaria 250ml',
    description: 'Miel pura de flores de araucaria, cosechada artesanalmente',
    price: 12000,
    image: 'https://images.unsplash.com/photo-1471943311424-646960669fbc?w=600&h=400&fit=crop',
    stock: 8,
    category: 'Mieles',
  },
  {
    id: 3,
    name: 'Aceite de Araucaria 500ml',
    description: 'Aceite prensado en frío de semillas de araucaria',
    price: 28000,
    image: 'https://images.unsplash.com/photo-1506976785307-8732e854ad03?w=600&h=400&fit=crop',
    stock: 12,
    category: 'Aceites',
  },
  {
    id: 4,
    name: 'Mix Frutos Secos 1kg',
    description: 'Mezcla premium de almendras, nueces y avellanas',
    price: 15000,
    image: 'https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?w=600&h=400&fit=crop',
    stock: 5,
    category: 'Frutos Secos',
  },
  {
    id: 5,
    name: 'Mermelada Artesanal 350g',
    description: 'Mermelada de frutilla sin conservantes artificiales',
    price: 8500,
    image: 'https://images.unsplash.com/photo-1599599810769-bcde5a160d32?w=600&h=400&fit=crop',
    stock: 20,
    category: 'Conservas',
  },
  {
    id: 6,
    name: 'Quinoa Orgánica 500g',
    description: 'Quinoa real boliviana, certificada orgánica',
    price: 9500,
    image: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=600&h=400&fit=crop',
    stock: 18,
    category: 'Granos',
  },
  {
    id: 7,
    name: 'Té de Hierbas Medicinales',
    description: 'Mezcla de hierbas chilenas: boldo, menta y manzanilla',
    price: 6500,
    image: 'https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=600&h=400&fit=crop',
    stock: 25,
    category: 'Infusiones',
  },
  {
    id: 8,
    name: 'Palta Hass Orgánica',
    description: 'Paltas premium del valle central, maduración perfecta',
    price: 3200,
    image: 'https://images.unsplash.com/photo-1523049673857-eb18f1d7b578?w=600&h=400&fit=crop',
    stock: 0, // Sin stock para mostrar funcionalidad
    category: 'Frutas',
  },
];

const PublicHome: React.FC = () => {
  const navigate = useNavigate();
  const { AuthModalComponent } = useAuthModal();

  const handleWhatsApp = () => {
    window.open('https://wa.me/56949275045?text=Hola!%20Quiero%20hacer%20un%20pedido', '_blank');
  };

  return (
    <Box>
      {/* Navigation */}
      <PublicNavigation />

      {/* Hero Section */}
      <HeroSection>
        <HeroText>
          <h2>Tu minimarket online</h2>
          <h1>Productos<br />locales y<br />artesanales</h1>
          <p>Descubre la frescura y calidad de nuestros productos locales, seleccionados especialmente para ti.</p>
          <StyledButton onClick={() => navigate('/productos')}>
            Ver catálogo
          </StyledButton>
        </HeroText>
        <HeroImage>
          <img
            src="https://images.unsplash.com/photo-1610832958506-aa56368176cf?w=800&h=600&fit=crop"
            alt="Caja de verduras frescas"
          />
        </HeroImage>
      </HeroSection>

      {/* Products Section */}
      <ProductsSection id="productos">
        <Typography variant="h2" component="h2" className="title">
          Productos destacados
        </Typography>
        <Typography className="subtitle">
          Lo mejor de nuestra selección artesanal
        </Typography>

        <Box sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: 4,
          maxWidth: '1200px',
          margin: '0 auto 50px'
        }}>
          {publicProducts.map((producto) => (
            <ProductCard key={producto.id}>
              <ProductImage src={producto.image} alt={producto.name} />
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#333' }}>
                  {producto.name}
                </Typography>
              </CardContent>
            </ProductCard>
          ))}
        </Box>

        <WhatsAppButton onClick={handleWhatsApp}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
          Haz tu pedido por WhatsApp
        </WhatsAppButton>
      </ProductsSection>

      {/* Footer */}
      <StyledFooter>
        <Container maxWidth="lg">
          <Box sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' },
            gap: 4,
            mb: 4
          }}>
            <Box textAlign="center">
              <Box
                component="img"
                src="/assets/logos/logo-el-pinon-nuevo.png"
                alt="El Piñón - Hacienda Las Araucarias Quillota"
                sx={{ 
                  width: 120, 
                  height: 120, 
                  mx: 'auto', 
                  mb: 2,
                  borderRadius: '50%',
                  objectFit: 'cover',
                }}
              />
              <Typography variant="h5" component="h3" sx={{ fontFamily: "'Playfair Display', serif", mb: 1 }}>
                EL PIÑÓN
              </Typography>
              <Typography variant="body2" sx={{ letterSpacing: 2, color: '#bbb' }}>
                MINIMARKET
              </Typography>
            </Box>
            
            <Box>
              <Typography variant="h6" sx={{ mb: 2, color: '#ffdb9b', fontFamily: "'Playfair Display', serif" }}>
                Navegación
              </Typography>
              <Box>
                <Typography component="a" href="/productos" sx={{ display: 'block', color: '#ddd', mb: 1, textDecoration: 'none', '&:hover': { color: '#ffdb9b' } }}>
                  Productos
                </Typography>
                <Typography component="a" href="#nosotros" sx={{ display: 'block', color: '#ddd', mb: 1, textDecoration: 'none', '&:hover': { color: '#ffdb9b' } }}>
                  Nosotros
                </Typography>
                <Typography component="a" href="#contacto" sx={{ display: 'block', color: '#ddd', mb: 1, textDecoration: 'none', '&:hover': { color: '#ffdb9b' } }}>
                  Contacto
                </Typography>
                <Typography component="a" href="#promociones" sx={{ display: 'block', color: '#ddd', mb: 1, textDecoration: 'none', '&:hover': { color: '#ffdb9b' } }}>
                  Promociones
                </Typography>
              </Box>
            </Box>
            
            <Box>
              <Typography variant="h6" sx={{ mb: 2, color: '#ffdb9b', fontFamily: "'Playfair Display', serif" }}>
                Contacto
              </Typography>
              <Typography sx={{ color: '#ddd', mb: 1 }}>📧 info@elpinon.com</Typography>
              <Typography sx={{ color: '#ddd', mb: 1 }}>📱 +56 9 1234 5678</Typography>
              <Typography sx={{ color: '#ddd', mb: 1 }}>📍 Santiago, Chile</Typography>
            </Box>
            
            <Box>
              <Typography variant="h6" sx={{ mb: 2, color: '#ffdb9b', fontFamily: "'Playfair Display', serif" }}>
                Horarios
              </Typography>
              <Typography sx={{ color: '#ddd', mb: 1 }}>Lunes - Viernes: 9:00 - 19:00</Typography>
              <Typography sx={{ color: '#ddd', mb: 1 }}>Sábados: 10:00 - 14:00</Typography>
              <Typography sx={{ color: '#ddd', mb: 1 }}>Domingos: Cerrado</Typography>
            </Box>
          </Box>
          
          <Box textAlign="center" sx={{ pt: 3, borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
            <Typography variant="body2" sx={{ color: '#999' }}>
              &copy; 2025 El Piñón Minimarket. Todos los derechos reservados.
            </Typography>
          </Box>
        </Container>
      </StyledFooter>

      {/* Auth Modals */}
      <AuthModalComponent />
    </Box>
  );
};

export default PublicHome;